import { render, staticRenderFns } from "./BeerTaps.vue?vue&type=template&id=0f03d6ad&"
import script from "./BeerTaps.vue?vue&type=script&lang=js&"
export * from "./BeerTaps.vue?vue&type=script&lang=js&"
import style0 from "./BeerTaps.vue?vue&type=style&index=0&id=0f03d6ad&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f03d6ad')) {
      api.createRecord('0f03d6ad', component.options)
    } else {
      api.reload('0f03d6ad', component.options)
    }
    module.hot.accept("./BeerTaps.vue?vue&type=template&id=0f03d6ad&", function () {
      api.rerender('0f03d6ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/kiosk/beer-taps/BeerTaps.vue"
export default component.exports